import filterObject from "@lib/filterObject"

export default function cleanSearchParams(currParams) {
  // clean params
  const JSONParams = ["location", "services", "subservices", "style", "bundle", "pricerange", "ids"]
  const otherParams = ["category", "name", "first", "skip", "order", "orderBy"]
  return {
    ...filterObject(currParams, JSONParams, true),
    ...filterObject(currParams, otherParams),
  }
}
